import { render } from "./PokemonList.vue?vue&type=template&id=657630df&scoped=true&ts=true"
import script from "./PokemonList.vue?vue&type=script&lang=ts"
export * from "./PokemonList.vue?vue&type=script&lang=ts"

import "./PokemonList.vue?vue&type=style&index=0&id=657630df&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657630df"]])